import { Schema } from "effect";
import { HttpApiEndpoint, HttpApiGroup, HttpApiSchema } from "effect/unstable/httpapi";
import { COMPILER_BENCHMARK_RESET_PATH } from "./compiler-experiment.ts";

export const CompilerWorkerVersion = /* @__PURE__ */ (() => Schema.String.check(Schema.isPattern(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/)).pipe(Schema.brand("CompilerWorkerVersion")))();
export type CompilerWorkerVersion = typeof CompilerWorkerVersion.Type;
export const CompilerBenchmarkResponse = /* @__PURE__ */ (() => Schema.Struct({
  ok: Schema.Literal(true), resource: Schema.Struct({ kind: Schema.Literal("compiler-container"),
    id: Schema.String.check(Schema.isPattern(/^(direct|mesh)-compiler-[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/)),
    action: Schema.Literal("stopped") })
}))();
export type CompilerBenchmarkResponse = typeof CompilerBenchmarkResponse.Type;
export const CompilerBenchmarkHeaders = /* @__PURE__ */ (() => Schema.Struct({
  "x-workerstation-compiler-placement": Schema.optionalKey(Schema.String), "x-workerstation-compiler-carrier": Schema.optionalKey(Schema.String),
  "x-workerstation-compiler-state-transfer": Schema.optionalKey(Schema.String), "x-workerstation-compiler-mode": Schema.optionalKey(Schema.String)
}))();
export const CompilerBenchmarkApi = HttpApiGroup.make("compilerBenchmark").add(
  HttpApiEndpoint.post("reset", COMPILER_BENCHMARK_RESET_PATH, { headers: CompilerBenchmarkHeaders, success: CompilerBenchmarkResponse,
    error: [Schema.Struct({ error: Schema.String }).annotate({ httpApiStatus: 400 }), Schema.Literal("Not found").pipe(HttpApiSchema.asText()).annotate({ httpApiStatus: 404 }),
      Schema.Struct({ error: Schema.String }).annotate({ httpApiStatus: 500 })] })
);
